import { render, staticRenderFns } from "./photos.vue?vue&type=template&id=8bddb818&"
import script from "./photos.vue?vue&type=script&lang=js&"
export * from "./photos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports